export function cepMask(cep = '') {
    if (!cep) throw new Error('CEP não informado')

    return cep.replace(/(\d{5})(\d{3})/, '$1-$2')
}
